import { resolveBrandId } from "@/config/uiTokens";

/**
 * Inson palitrasi uchun yumshoq yashil ambient blur.
 * Click / boshqa super-app brandlarida Figma `bg/ocean` (#141414) ustiga
 * qattiq yashil doiralar tint bermasligi uchun chiqarilmaydi.
 */
export function AmbientBackground() {
  if (resolveBrandId() !== "default") {
    return null;
  }

  return (
    <div
      className="fixed inset-0 overflow-hidden pointer-events-none"
      aria-hidden
      style={{ opacity: "var(--ambient-opacity, 1)" }}
    >
      <div className="absolute -top-40 -left-24 w-[28rem] h-[28rem] rounded-full blur-3xl" style={{ background: "rgba(26,107,74,0.18)" }} />
      <div className="absolute top-1/3 -right-28 w-80 h-80 rounded-full blur-3xl" style={{ background: "rgba(46,139,94,0.12)" }} />
      <div className="absolute -bottom-24 left-1/3 w-72 h-72 rounded-full blur-3xl" style={{ background: "rgba(76,175,130,0.10)" }} />
    </div>
  );
}
